let Ajax = require("../lib/Ajax");

class HelpView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      content: null
    };
  }

  componentDidMount() {
    let path = this.props.path;

    Ajax.get(path).then((function (response) {
      this.setState({ content: response });
    }).bind(this));
  }

  render() {
    let content = this.state.content;

    let markup = function () {
      return { __html: content };
    };

    return (
      <div className="mc-help-view">
        <header>
          <img src="./img/mc/help.svg" width="70" height="70"/>
        </header>
        <div dangerouslySetInnerHTML={markup()}/>
      </div>
    );
  }
}

module.exports = HelpView;